// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header */

.header {
  background-color: var(--light-blackBg);
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 3;
  display: flex;
  justify-content: space-between;
}

.header-menus {
  display: flex;
  flex-direction: column;
}

.header ul {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: var(--light-blackBg);
  place-content: center;
}

.header li a {
  display: block;
  padding: 20px 20px;
  border-right: 1px solid #f4f4f4;
}

/* menu */

.header .menu {
  clear: both;
  max-height: 0;
  min-height: 0;
  transition: min-height 0.5s ease-out;
  display: flex;
  flex-direction: column;
  min-height: 'auto';
  text-align: center;
}

/* menu icon */

.header .menu-icon {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  padding: 28px 20px;
  position: relative;
  user-select: none;
}

.header .menu-icon .navicon {
  background: #6e6e6e;
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.6s ease-out;
  width: 18px;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #6e6e6e;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

.header .menu_checked {
  min-height: 65vh;
  text-align: center;
}

.header .force-menu-close {
  min-height: 0 !important;
}

.header .menu-icon_checked .navicon_checked {
  background: transparent;
}

.header .menu-icon_checked .navicon_checked:before {
  transform: rotate(-45deg);
}

.header .menu-icon_checked .navicon_checked:after {
  transform: rotate(45deg);
}

.header
  .menu-btn:checked
  ~ .menu-icon_checked:not(.steps)
  .navicon_checked:before,
.header
  .menu-btn:checked
  ~ .menu-icon_checked:not(.steps)
  .navicon_checked:after {
  top: 0;
}

.languages {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/* 48em = 768px */

@media (min-width: 48em) {
  .header li {
    float: left;
  }
  .header li a {
    padding: 20px 30px;
  }
  .header .menu {
    clear: none;
    float: right;
    max-height: none;

    flex-direction: row;
  }
  .header .menu-icon {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/mainHeader.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,eAAe;EACf,WAAW;EACX,MAAM;EACN,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,SAAS;;AAET;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,cAAc;;AAEd;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;;IAEhB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* header */\n\n.header {\n  background-color: var(--light-blackBg);\n  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.1);\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 3;\n  display: flex;\n  justify-content: space-between;\n}\n\n.header-menus {\n  display: flex;\n  flex-direction: column;\n}\n\n.header ul {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: var(--light-blackBg);\n  place-content: center;\n}\n\n.header li a {\n  display: block;\n  padding: 20px 20px;\n  border-right: 1px solid #f4f4f4;\n}\n\n/* menu */\n\n.header .menu {\n  clear: both;\n  max-height: 0;\n  min-height: 0;\n  transition: min-height 0.5s ease-out;\n  display: flex;\n  flex-direction: column;\n  min-height: 'auto';\n  text-align: center;\n}\n\n/* menu icon */\n\n.header .menu-icon {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  padding: 28px 20px;\n  position: relative;\n  user-select: none;\n}\n\n.header .menu-icon .navicon {\n  background: #6e6e6e;\n  display: block;\n  height: 2px;\n  position: relative;\n  transition: background 0.6s ease-out;\n  width: 18px;\n}\n\n.header .menu-icon .navicon:before,\n.header .menu-icon .navicon:after {\n  background: #6e6e6e;\n  content: '';\n  display: block;\n  height: 100%;\n  position: absolute;\n  transition: all 0.2s ease-out;\n  width: 100%;\n}\n\n.header .menu-icon .navicon:before {\n  top: 5px;\n}\n\n.header .menu-icon .navicon:after {\n  top: -5px;\n}\n\n.header .menu_checked {\n  min-height: 65vh;\n  text-align: center;\n}\n\n.header .force-menu-close {\n  min-height: 0 !important;\n}\n\n.header .menu-icon_checked .navicon_checked {\n  background: transparent;\n}\n\n.header .menu-icon_checked .navicon_checked:before {\n  transform: rotate(-45deg);\n}\n\n.header .menu-icon_checked .navicon_checked:after {\n  transform: rotate(45deg);\n}\n\n.header\n  .menu-btn:checked\n  ~ .menu-icon_checked:not(.steps)\n  .navicon_checked:before,\n.header\n  .menu-btn:checked\n  ~ .menu-icon_checked:not(.steps)\n  .navicon_checked:after {\n  top: 0;\n}\n\n.languages {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n/* 48em = 768px */\n\n@media (min-width: 48em) {\n  .header li {\n    float: left;\n  }\n  .header li a {\n    padding: 20px 30px;\n  }\n  .header .menu {\n    clear: none;\n    float: right;\n    max-height: none;\n\n    flex-direction: row;\n  }\n  .header .menu-icon {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
